import config from "../../config"
import RequestService from "../RequestService"

const createTicket = (params, successCallback, failureCallback) => {
  RequestService.post(`${config.backendUrl}/tickets`, { ticket: params }, successCallback, failureCallback)
}

export default createTicket;